import jwtDecode from 'jwt-decode';
import { ipc, setSessionItem } from '~/services/application.service';
import axiosInstance, { fetchData } from '~/services/http.service';
import { INITIATE_LOGIN_MUTATION } from '../graphql/mutations/auth.mutations';
import { GET_CLIENT_TOKEN_QUERY, GET_OFFICER_DATA_QUERY, GET_OFFICER_REFRESH_TOKEN_QUERY, } from '../graphql/queries/auth.queries';
export const getOfficerData = async (county, username) => {
    const variables = {
        county,
        username,
    };
    const response = await fetchData(GET_OFFICER_DATA_QUERY, variables);
    const { getOfficerByUsername } = response;
    return getOfficerByUsername;
};
export const login = async (loginId, password) => {
    var _a;
    const clientResponse = await getClientToken();
    const mutation = INITIATE_LOGIN_MUTATION;
    const variables = {
        client: 'PHOENIX',
        username: loginId.trim(),
        password,
    };
    const options = {
        headers: {
            Authorization: `Bearer ${clientResponse.token}`,
        },
        data: {
            query: mutation,
            variables,
        },
    };
    const response = await axiosInstance(options);
    const { data, errors } = await response.data;
    if (errors) {
        throw new Error('Something went wrong.');
    }
    const { initiateLogin } = data;
    const { __typename, message } = initiateLogin;
    if (__typename !== 'AuthenticationData') {
        return { error: message };
    }
    const localCounties = (_a = process.env.LOCAL_COUNTIES) === null || _a === void 0 ? void 0 : _a.split(',').map((item) => item.trim());
    const updatedCounties = process.env.LOCAL_COUNTIES
        ? initiateLogin.counties.filter((county) => localCounties.includes(county.value) ? county : null)
        : initiateLogin.counties;
    setSessionItem('token', initiateLogin.accessToken);
    setSessionItem('refreshToken', initiateLogin.refreshToken);
    setSessionItem('username', initiateLogin.id);
    setSessionItem('officerId', process.env.OFFICER_ID);
    setSessionItem('counties', JSON.stringify(updatedCounties));
    return {
        ...initiateLogin,
        counties: updatedCounties,
        username: initiateLogin.id,
    };
};
const getOfficerRefreshToken = async (refreshToken) => {
    const options = {
        data: {
            query: GET_OFFICER_REFRESH_TOKEN_QUERY,
            variables: { refreshToken },
        },
    };
    const response = await axiosInstance(options);
    const { data: { officerRefreshToken: { refreshToken: updatedRefreshToken, token: updatedToken, error, passwordExpired, }, }, } = response.data;
    return {
        refreshToken: updatedRefreshToken,
        token: updatedToken,
        error,
        passwordExpired,
    };
};
export const validateTokens = async (token, refreshToken) => {
    const decodedToken = jwtDecode(token);
    const currentTime = new Date().getTime() / 1000;
    if (decodedToken.exp < currentTime) {
        const decodedRefreshToken = jwtDecode(refreshToken);
        if (decodedRefreshToken.exp < currentTime) {
            throw new Error('expired-session');
        }
        const response = await getOfficerRefreshToken(refreshToken);
        const { refreshToken: updatedRefreshToken, token: updatedToken, error, } = response;
        if (error) {
            throw new Error(error);
        }
        ipc('windowAction', {
            action: 'dashboardTokenUpdate',
            isSync: false,
            params: {
                token: updatedToken,
                refreshToken: updatedRefreshToken,
            },
        }, '1');
        return { token: updatedToken, refreshToken: updatedRefreshToken };
    }
    return { token, refreshToken };
};
const getClientToken = async () => {
    const query = GET_CLIENT_TOKEN_QUERY;
    const variables = {
        clientName: process.env.CLIENT_NAME,
        password: process.env.CLIENT_PASSWORD,
    };
    const options = {
        data: {
            query,
            variables,
        },
    };
    const response = await axiosInstance(options);
    const { data: { validateClient }, } = await response.data;
    return validateClient;
};
